import { useTranslation } from 'react-i18next'

const DrunkParentStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="drunk-parent-start-title"
      {...props}
    >
      <title id="drunk-parent-start-title">{t('antagonists:drunkparent:components:start')}</title>
      <defs>
        <clipPath id="drunk-parent-b">
          <path
            d="M1635.96 463.75c-10.76 3.8-2.95 46.49-.79 57.25 2.16 10.77 7.27 45.64 12.15 68.02 4.87 22.39 8.9 22.52 8.9 22.52l1.4 19.08 33.74-2.81 2.24-22.42s12.17-4.45 9.51-27.55-22.76-75.83-28.39-90.85c-4.2-11.21-14.81-31.71-38.75-23.25Z"
            style={{
              fill: '#00a074',
            }}
          />
        </clipPath>
        <clipPath id="drunk-parent-c">
          <path
            d="M1514.48 326.89s24.44 13.86 44.05 15.23c19.61 1.37 21.31-7.4 21.31-7.4s12.22 5.99 24.57 13.3c9.13 5.4 28.61 12.49 30.21 23.72 1.36 9.52-22.75 66.13-20.01 96.68 2.74 30.55 18.89 81.66 19.26 93.14 1.02 31.75-4.99 37.53-4.99 37.53l-.02 19.47s-43.86 7.87-93.56 9.24-83.95-13.6-83.95-13.6l1.86-22.57s-11.21-11.26-5.74-28.13c5.47-16.87 12.29-59.84 13.2-78.08.91-18.24-2.44-45.26-6.09-73.53-3.65-28.27-5.02-70.67 11.4-75.23 16.41-4.56 28.4-5.49 34.78-6.4 6.38-.91 13.73-3.36 13.73-3.36Z"
            style={{
              fill: '#00a074',
            }}
          />
        </clipPath>
        <clipPath id="drunk-parent-d">
          <path
            d="M1443.04 514.33c11.48-11.08 23.17-17.75 20.95-29.91-2.22-12.16-13-36.66-16.19-43.94s-8.67-19.08-8.67-19.08l-2.6-20.81-36.42 2.6 1.73 21.97s-6.91 10.88-5.2 32.95 11.17 44.23 15.02 53.14c5.32 12.33 20.34 13.74 31.38 3.08Z"
            style={{
              fill: '#00a074',
            }}
          />
        </clipPath>
        <style>
          {
            '.e{fill:#00a79b}.f{fill:#eee5db}.g{fill:#6b5738}.h{fill:#00a074}.i{fill:#940c3b}.j{fill:#d88b46}.k{fill:#e2a972}.l{fill:#2e425b}.m{fill:#513427}.n{clip-path:url(#drunk-parent-c)}.o{clip-path:url(#drunk-parent-b)}.p{clip-path:url(#drunk-parent-d)}'
          }
        </style>
      </defs>
      <path
        d="M1662.52 624.71s-4.24 9.6-5.05 12.62c-.8 3.02-2.91 12.97-3.11 15.32-.2 2.34 2.75 20.83 2.75 20.83s4.21-.36 5.8-4.04c1.59-3.68-.13-13.27 1.76-16.2 1.47-2.29 3.53-.97 3.32 1.56-.22 2.52-.43 12.35-.56 13.79-.12 1.44-4.36 5.4-5.48 7.85-1.12 2.45 1.68 5.78 1.68 5.78s9.64-2.26 11.01-3.41 1.29-4.43 2.96-4.83 5.64-2.24 5.81-4.22c.17-1.98 2.55-2.14 3.95-3.66 1.4-1.51.52-3.95 2.19-4.35s4.86-1.58 5.52-2.98c.66-1.4.92-13.2.54-17.23-.38-4.03-5.84-14.77-5.94-17.87s1.76-15.54 1.76-15.54l-24.84-2.68s-3.11 14.44-4.07 19.26Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1423.89 909.17s4.11 32.57-7.99 48.53c-12.1 15.96-22.59 20.52-29.29 22.03-6.7 1.51-26.71 2.3-30.49 7.53-3.78 5.24-2.79 17.1-2.79 17.1s24.74 4.56 40.97 3.01c16.23-1.55 35.04-7.33 40.92-8.92 5.87-1.59 7.21-.1 7.21-.1l.58 4.67 38.66-4.39s3.32-13.37-1.48-25.96c-4.8-12.59-9.8-28.94-11.23-37.64-1.44-8.71-.76-29.77-.76-29.77l-44.3 3.9ZM1522.34 910.92s2.82 41.67-.31 48.88c-3.13 7.21-5.95 21.3-5.95 21.3l5.33 4.39h4.7s0 13.79.94 16.61c.94 2.82 10.65 10.34 20.99 11.59 10.34 1.25 25.06.94 28.2-2.51 3.13-3.45 6.27-14.41-2.19-23.81-8.46-9.4-17.55-22.87-19.11-29.76-1.57-6.89-1.88-23.81-1.88-31.02 0-7.21 4.07-18.49 4.07-18.49l-34.78 2.82Z"
        style={{
          fill: '#513427',
        }}
      />
      <path
        d="M1477.43 522.7s-1.76 22.89-8.32 41.13c-6.57 18.25-42.03 142.79-46.41 163.95-4.38 21.17-20.59 217.52-20.59 217.52s36 6.15 54.24 8.34c18.25 2.19 30.65-2.19 30.65-2.19s-4.46-89.38-.08-141.92c4.38-52.55-2.69-49.34 8.99-69.77 11.68-20.44 58.89-122.17 72.76-144.07 13.87-21.9 12.41-81.74 12.41-81.74s-28.46 8.03-49.63 8.03-54.01.73-54.01.73Z"
        style={{
          fill: '#940c3b',
        }}
      />
      <path
        d="M1532.9 578.9c-1.43 3.9 1.58 147.78-3.59 188.29-5.41 42.39-31.07 169.76-31.07 169.76s25.54 16.79 45.98 17.52c20.44.73 42.93-6.23 42.93-6.23s2.74-108.8 12.23-158.42c9.49-49.63 31.28-184.94 27.63-217.78-3.65-32.84-22.58-67.58-22.58-67.58s-18.98 10.22-40.87 13.87c-21.9 3.65-50.36 2.92-50.36 2.92l19.71 57.66Z"
        style={{
          fill: '#940c3b',
        }}
      />
      <path
        d="M1539.68 202.58c-4.11-1.27-7.77-2.8-14.04-1.41-6.26 1.39-9.1 4.34-9.1 4.34l9.31 1.32s-13.76 2.2-18.84 9.64c-5.09 7.43-5.22 11.76-5.22 11.76l4.9-3.79s-5.41 6.32-5.59 13.15c-.18 6.82 11.51 47.16 11.51 47.16s71.92-3.38 69.85-8.22c-.57-1.33 2.61-21.39 3.13-26.88.52-5.49 2.24-10.62.27-14.78-1.98-4.16-3.99-8.77-3.99-8.77l4.99 3.47s-3.8-12.42-9.22-15.4c-5.42-2.98-9.85-2.19-9.85-2.19s1.6-3.76 4.21-3.51c2.62.25 4.71-.14 4.71-.14s-2.06-5.29-9.82-4.91c-7.76.38-11.19 1.78-11.19 1.78s.93-3.25-3.69-4.94c-4.62-1.69-12.33 2.32-12.33 2.32Z"
        style={{
          fill: '#eee5db',
        }}
      />
      <path
        d="M1551.73 321.09c15.04-4.12 20.34-14.31 24.67-19.91 4.41-5.7 1.21-16.31 2.27-17.33 1.06-1.02 5.17 1.45 8.33-7.6 3.15-9.05 4.5-19.05.65-18.75-4 .31-5.26 4.86-6.17 8.69-.91 3.79-2.69 8.61-2.69 8.61l-2.83.7s1.21-17.26-4.28-28.89c-5.48-11.63-6.3-15.97-10.27-14.27-3.97 1.7 5.74 11.84 5.74 11.84s-9.37 1.88-16.58-4.05c-7.21-5.93-9.91-8.03-9.91-8.03s-.56 2.13.89 5.26c1.45 3.13 3.56 5.52 3.56 5.52s-8.09 1.32-13.65-1.95c-5.56-3.28-7.96-6.34-7.96-6.34s1.48 3.59 1.84 8.2c.36 4.61-2.54 6.56-2.54 6.56s-.16-1.02-.8-3.06-1.74-3.81-1.74-3.81-2.54 7.71-3.53 13.49c-.99 5.77 3.92 24.54 3.92 24.54l-2.67-.26s-8.31-19.1-12.54-17.61c-4.22 1.49-.75 12.11 1.1 17.3 1.85 5.19 4.1 9.42 6.76 9.44 2.65.03 4.51-.43 4.83.09s.89 11.52 4.38 16.12c3.49 4.6 16.07 14.52 19.95 14.91 3.89.39 6.9 1.23 9.26.59Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1522.21 287.45s6.52 20.98.11 32.51c-4.14 7.44-15.16 9.9-22.69 11.6-7.83 1.77-21.39 2.92-21.39 2.92l2.69 42.73 120.27-4.04-5.47-23.82s-15.6-11.99-19.53-18.99c-9.34-16.66-1.49-40.16-1.49-40.16l-52.49-2.73Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1535.68 300.75c.78.99 2.14.98 3.31 1.46 1.76.72 5.08 3.23 8.81 2.46 3.72-.77 6.79-2.13 8.48-2.46 1.69-.34 4.23-1.7 3.9-3.12-.32-1.42-5.28-3.51-6.72-3.91-2.27-.64-4.63.59-5.99.56s-3.71-.49-6.34.54-6.54 3.09-5.45 4.48Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="M1552.42 262.16s6.3-3.85 11.31-4.12c5.02-.27 7.03 1.5 7.03 1.5l-.33 2.17s-2.29-.79-7.26-.31c-6.59.63-8.9 2.86-8.9 2.86l-1.84-2.09ZM1538.78 266.08l.18-2.62s-6.47-3.47-12.09-2.66-6.88 3.2-6.88 3.2l.97 1.88s3.13-2.63 8.09-1.9 9.72 2.1 9.72 2.1Z"
        style={{
          fill: '#6b5738',
        }}
      />
      <path
        d="M1530.88 268.47c-1.56.68-2.2 2.2-1.48 3.71.72 1.5 1.98 1.69 3.42 1.17 1.7-.61 2.93-2.52 1.62-3.64-1.79-1.53-1.96-1.94-3.56-1.24Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#2e425b',
        }}
        d="m1526.29 269.08 9.1.92.44-2.06-9.05-1.7-.49 2.84zM1560.4 265.87c1.64.43 2.52 1.84 2.03 3.43-.48 1.6-1.87 2.05-3.36 1.76-1.77-.34-2.33-1.73-2-3.41.23-1.19 1.64-2.22 3.33-1.78Z"
      />
      <path
        style={{
          fill: '#2e425b',
        }}
        d="m1565.37 265.93-8.97 3.13-.59-2.29 8.23-3.75 1.33 2.91z"
      />
      <path
        d="M1597.51 441.46s32.77 58 35.05 71.68c2.28 13.68 2.71 27.5 25.05 27.5s16.26-35.29 15.35-53.07c-.91-17.78-30.08-116.26-42.85-124.02-12.77-7.75-39.13-20.82-46.43-8.05-7.3 12.77 13.82 85.96 13.82 85.96ZM1464.15 337.57c-20.68 7.82-33.91 41.54-41.21 78.92-7.3 37.39-13.96 70.17-5.3 78.83 8.66 8.66 29.18 18.24 37.84 2.74 8.66-15.5 15.05-67.48 21.89-77.97 6.84-10.49 17.33-36.48 10.94-54.71-6.38-18.24-15.58-31.06-24.17-27.81Z"
        style={{
          fill: '#00a074',
        }}
      />
      <path
        d="M1635.96 463.75c-10.76 3.8-2.95 46.49-.79 57.25 2.16 10.77 7.27 45.64 12.15 68.02 4.87 22.39 8.9 22.52 8.9 22.52l1.4 19.08 33.74-2.81 2.24-22.42s12.17-4.45 9.51-27.55-22.76-75.83-28.39-90.85c-4.2-11.21-14.81-31.71-38.75-23.25Z"
        style={{
          fill: '#00a074',
        }}
      />
      <g
        style={{
          clipPath: 'url(#drunk-parent-b)',
        }}
      >
        <path
          d="M1650.3 612.33s9.25-1.45 23.41-3.18c14.06-1.72 13.61-1.61 30.06-5.2l-.58 31.22-48.56 4.91-4.34-27.75Z"
          style={{
            fill: '#00a79b',
          }}
        />
      </g>
      <path
        d="M1514.48 326.89s24.44 13.86 44.05 15.23c19.61 1.37 21.31-7.4 21.31-7.4s12.22 5.99 24.57 13.3c9.13 5.4 28.61 12.49 30.21 23.72 1.36 9.52-22.75 66.13-20.01 96.68 2.74 30.55 18.89 81.66 19.26 93.14 1.02 31.75-4.99 37.53-4.99 37.53l-.02 19.47s-43.86 7.87-93.56 9.24-83.95-13.6-83.95-13.6l1.86-22.57s-11.21-11.26-5.74-28.13c5.47-16.87 12.29-59.84 13.2-78.08.91-18.24-2.44-45.26-6.09-73.53-3.65-28.27-5.02-70.67 11.4-75.23 16.41-4.56 28.4-5.49 34.78-6.4 6.38-.91 13.73-3.36 13.73-3.36Z"
        style={{
          fill: '#00a074',
        }}
      />
      <g
        style={{
          clipPath: 'url(#drunk-parent-c)',
        }}
      >
        <path
          d="M1536.19 343.49c15.19 7.01 34.85 6.7 43.05 1.58 11.79-7.37 18.83-17.15 18.83-17.15l-14.46-24.09-74.78-1.37-22.92 17.07s34.94 16.89 50.28 23.96ZM1641.84 597.01c-58.54 11.65-88.01 10.15-112.83 10.85-55.87 1.58-94.14-23.27-94.14-23.27l-7.07 47.31 214.39 7.58-.35-42.47Z"
          style={{
            fill: '#00a79b',
          }}
        />
      </g>
      <path
        d="M1414.77 426.47s-11.31-20.03-12.91-24.34c-1.6-4.31-10.71-20.45-11.67-24.2-.95-3.75.86-20.21 1.3-21.64.44-1.43 5.15-23.51 5.15-23.51s6.11-.48 6.83 5.13c.27 2.1-1.2 10.76-2.52 13.03-.89 1.52 1.36 8.64 1.8 8.82.75.31 7.14-6.48 9.03-6.53 2.66-.08 15.19 11.08 14.85 14.09-.35 3.19-1.58 11.04-1.37 13.03.21 1.99 4.52 10.71 2.73 14.36-1.78 3.66-1.68 4.91-.54 7.13 1.14 2.22 9.22 11.06 9.22 11.06l-21.89 13.57Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1443.04 514.33c11.48-11.08 23.17-17.75 20.95-29.91-2.22-12.16-13-36.66-16.19-43.94s-8.67-19.08-8.67-19.08l-2.6-20.81-36.42 2.6 1.73 21.97s-6.91 10.88-5.2 32.95 11.17 44.23 15.02 53.14c5.32 12.33 20.34 13.74 31.38 3.08Z"
        style={{
          fill: '#00a074',
        }}
      />
      <g
        style={{
          clipPath: 'url(#drunk-parent-d)',
        }}
      >
        <path
          d="M1447.22 421.11s-12.73-1.52-26.88.29c-14.15 1.8-27.75 4.62-27.75 4.62l-1.31-38.68 48.54-5.15 7.41 38.92Z"
          style={{
            fill: '#00a79b',
          }}
        />
      </g>
    </svg>
  )
}

export default DrunkParentStart